var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { isBlank, isEmptyArray, isEmptyObject } from '@autobest-ui/utils';
var fixedValue = function fixedValue(value) {
  if (isBlank(value)) {
    return 0;
  }
  return parseFloat(value.toFixed(2));
};
var getElementClassNameOrId = function getElementClassNameOrId(element) {
  if (!element) {
    return '';
  }
  if (!isBlank(element.className) || !isBlank(element.id)) {
    return element.className || element.id;
  }
  // 对没有className, id 的元素，进行处理，往上级去找，并累加p_
  var prefix = 'p_';
  while (element.parentNode) {
    if (!isBlank(element.parentNode.className) || !isBlank(element.parentNode.id)) {
      return "".concat(prefix).concat(element.parentNode.className || element.parentNode.id);
    }
    element = element.parentNode;
    prefix += 'p_';
  }
  return '';
};
var extendElementProps = function extendElementProps(prevInfo, element) {
  if (isEmptyObject(element)) {
    return prevInfo;
  }
  var result = __assign(__assign({}, prevInfo), {
    tagName: element.tagName,
    classNameOrId: getElementClassNameOrId(element)
  });
  if (result.tagName === 'IMG' && !result.src) {
    result.src = element.src;
  }
  // 过滤掉重复数据
  if (prevInfo.currentRect) {
    return result;
  }
  result.width = element.offsetWidth;
  result.height = element.offsetHeight;
  return result;
};
export default {
  /**
   * First Contentful Paint
   * @param info
   * @param callback
   */
  fcp: function fcp(info, callback) {
    callback({
      value: fixedValue(info.value),
      name: info.name
    });
  },
  /**
   * Reduce server response times
   * @param info
   * @param callback
   */
  ttfb: function ttfb(info, callback) {
    var desc = {};
    if (!isEmptyArray(info.entries)) {
      // 只需要获取第一个数组即可
      var item = info.entries[0];
      desc = {
        duration: fixedValue(item.duration),
        fetchStart: fixedValue(item.fetchStart),
        requestStart: fixedValue(item.requestStart),
        responseStart: fixedValue(item.responseStart),
        responseEnd: fixedValue(item.responseStart)
      };
    }
    callback({
      value: fixedValue(info.value),
      name: info.name,
      desc: desc
    });
  },
  /**
   * First Input Delay
   * @param info
   * @param minValue
   * @param callback
   */
  fid: function fid(info, minValue, callback) {
    var desc = {};
    // 当超出临界值，收集详细信息
    if (info.value > minValue && !isEmptyArray(info.entries)) {
      // 只需要获取第一个数组即可
      var item = info.entries[0];
      desc = extendElementProps({
        name: item.name,
        duration: fixedValue(item.duration),
        cancelable: item.cancelable,
        startTime: fixedValue(item.startTime),
        processingStart: fixedValue(item.processingStart),
        processingEnd: fixedValue(item.processingEnd)
      }, item.target);
    }
    callback({
      value: fixedValue(info.value),
      name: info.name,
      desc: desc
    });
  },
  /**
   * Largest Contentful Paint
   * @param info
   * @param minValue
   * @param callback
   */
  lcp: function lcp(info, minValue, callback) {
    var desc = {};
    // 当超出临界值，收集详细信息
    if (info.value > minValue && !isEmptyArray(info.entries)) {
      for (var i = 0, l = info.entries.length, item = void 0; i < l; i++) {
        item = info.entries[i];
        if (item.loadTime === info.value || item.startTime === info.value) {
          desc = extendElementProps({
            duration: fixedValue(item.duration),
            loadTime: fixedValue(item.loadTime),
            src: item.url
          }, item.element);
          break;
        }
      }
    }
    callback({
      value: fixedValue(info.value),
      name: info.name,
      desc: desc
    });
  },
  /**
   * Cumulative Layout Shift
   * @param info
   * @param minValue
   * @param callback
   */
  cls: function cls(info, minValue, callback) {
    var desc = null;
    // 当超出临界值，收集详细信息
    if (info.value > minValue && !isEmptyArray(info.entries)) {
      var findMaxValueOfIndex = 0;
      var findMaxValue = 0;
      for (var i = 0, l = info.entries.length, item = void 0; i < l; i++) {
        item = info.entries[i];
        if (item.value > findMaxValue) {
          findMaxValue = item.value;
          findMaxValueOfIndex = i;
        }
      }
      // 因为数据量比较大， 这里只找到最大的抖动元素，并收集，其他元素，暂时不收集，
      var findMaxItem = info.entries[findMaxValueOfIndex] || {};
      var sources_1 = [];
      if (!isEmptyArray(findMaxItem.sources)) {
        findMaxItem.sources.forEach(function (_a) {
          var _b = _a.currentRect,
            currentRect = _b === void 0 ? {} : _b,
            node = _a.node,
            _c = _a.previousRect,
            previousRect = _c === void 0 ? {} : _c;
          // node 不为空，进行收集
          if (!isEmptyObject(node)) {
            sources_1.push(extendElementProps({
              previousRect: {
                left: previousRect.left,
                top: previousRect.top,
                width: previousRect.width,
                height: previousRect.height
              },
              currentRect: {
                left: currentRect.left,
                top: currentRect.top,
                width: currentRect.width,
                height: currentRect.height
              }
            }, node));
          }
        });
      }
      // 收集sources不为空的情况
      if (sources_1.length > 0) {
        desc = {
          duration: fixedValue(findMaxItem.duration),
          startTime: fixedValue(findMaxItem.startTime),
          sources: sources_1
        };
      }
    }
    callback({
      // 这个不需要处理小数， 否则有可能得到的是0
      value: info.value,
      name: info.name,
      desc: desc
    });
  }
};